<template lang="pug">
.payout-hint-panel.panel(:class="panelClass")
  .panel-heading(v-if="heading")
    slot(name="heading") {{heading}}
  .panel-body
    slot
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'payout-hint-panel',
})
export default class PayoutHintPanel extends Vue {
  @Prop({ default: null })
  heading!: string

  @Prop({ default: false })
  warning!: boolean

  get panelClass() {
    return {
      'panel-warning': this.warning,
    };
  }
}
</script>

<style scoped lang="less">
.payout-hint-panel {
  margin-top: 0;
  border-top: 3px solid #80bd1c;
  font-size: 90%;
  .panel-heading {
    padding-bottom: 0;
  }

  &.panel-warning {
    border-top: 3px solid #eea236;
    background-color: #fcf8e3;
    .panel-heading {
      border: none;
    }
  }
  a {
    text-decoration: underline;
  }
}
</style>
